import type { LucideIcon } from "lucide-react";

import {
  Archive,
  BadgePercent,
  Boxes,
  ChartNoAxesCombined,
  Globe,
  Hash,
  LayoutGrid,
  Link2,
  Package,
  Percent,
  ReceiptText,
  SearchX,
  ShoppingCart,
  Store,
  Tag,
  Truck,
  Users,
  Image as ImageIcon,
} from "lucide-react";

export type NavItem = { label: string; href: string; icon: LucideIcon };
export type NavGroup = { label: string; items: NavItem[] };

export const NAV_GROUPS: NavGroup[] = [
  {
    label: "Catalog",
    items: [
      { label: "Products", href: "/products", icon: Package },
      { label: "Categories", href: "/categories", icon: LayoutGrid },
      { label: "Brands", href: "/brands", icon: Tag },
      { label: "Countries", href: "/countries", icon: Globe },
      { label: "Suppliers", href: "/suppliers", icon: Truck },
      { label: "Margins", href: "/margins", icon: Percent },
    ],
  },
  {
    label: "Sales",
    items: [
      { label: "Dashboard", href: "/dashboard", icon: ChartNoAxesCombined },
      { label: "Orders", href: "/orders", icon: ReceiptText },
      { label: "Carts", href: "/carts", icon: ShoppingCart },
      { label: "Promotions", href: "/promotions", icon: BadgePercent },
      { label: "Users", href: "/users", icon: Users },
      { label: "Storefront", href: "/storefront", icon: ImageIcon },
    ],
  },
  {
    label: "Search & SEO",
    items: [
      { label: "Keywords", href: "/keywords", icon: Hash },
      { label: "SEO slugs", href: "/seo-slugs", icon: Link2 },
      {
        label: "Zero-result searches",
        href: "/zero-result-searches",
        icon: SearchX,
      },
    ],
  },
  {
    label: "Scraped",
    items: [
      { label: "Products", href: "/scraped/products", icon: Archive },
      { label: "Categories", href: "/scraped/categories", icon: Boxes },
      { label: "Brands", href: "/scraped/brands", icon: Store },
    ],
  },
];

/** Actions the ⌘K menu offers beside the pages. Each opens its page with `?add=1`, which that page turns into an open dialog. */
export type CommandAction = { label: string; group: string; href: string };

export const COMMAND_ACTIONS: CommandAction[] = [
  { label: "Add brand", group: "Brands", href: "/brands?add=1" },
  { label: "Add country", group: "Countries", href: "/countries?add=1" },
  { label: "Add supplier", group: "Suppliers", href: "/suppliers?add=1" },
  { label: "Add promotion", group: "Promotions", href: "/promotions?add=1" },
];

/** With an empty query the ⌘K menu shows these pages and then the actions; typing searches every page. */
export const SHORT_GO_TO = [
  "/products",
  "/categories",
  "/brands",
  "/orders",
  "/carts",
  "/users",
  "/keywords",
  "/scraped/products",
];
